import Vue from 'vue';
import { tweetApi } from '../../api';
const requestConfig = require('../../../bin/config');
const apiDomain = process.env.VUE_ENV === 'server' ? requestConfig.apiDomain3 : '';

const state = {
    loading: true,
    articleInfo: {}
};

const getters = {
    // getLoading: state => state.loading,
    getArticleInfo: state => state.articleInfo
};

const actions = {
    getArticleInfo: ({ commit, state }, { article_id }) => {
        // articleId接收自页面组件asyncData的store.dispatch
        state.loading = true;
        let url = `${apiDomain}/app/tweet/info?type=tweet&id=${article_id}`;
        tweetApi.fetchTweetArticleInfo(url).then(data => commit('setTweetArticleInfo', { data }));
    }
};

const mutations = {
    setTweetArticleInfo (state, params) { // 获取文章信息
        state.loading = false;
        // state.articleInfo = params.data.data;
        Vue.set(state.articleInfo, params.data.data.id, params.data.data || false);
        console.log(state.articleInfo, 'articleInfo');
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/tweetStore.js